<template>
   <!--Page alert + loader-->
   <PageStatus :alert="defaultAlert" :table-data="tableData" />

   <h4 v-if="!inModal" class="sa-core-color fw-semibold mb-1">
      <i :class="[pageIcon, 'me-2 opacity-75']"></i>{{ pageTitle }}
   </h4>
   <p class="small sa-core-color opacity-75 mb-2">
      <i class="fa fa-info-circle me-1"></i>Switch on the modules your company uses. Switching one off only hides it: its data is kept.
   </p>

   <!--Modules-->
   <div class="card glass mt-0 bg-sa-card">
      <div class="card-body bg-sa-card-body p-2">

         <div v-if="modulesLoaded && !canManage" class="alert alert-info py-2 mb-2">
            <i class="fa fa-info-circle me-1"></i>Only an Administrator can switch modules on or off.
         </div>

         <div class="row g-3">
            <div v-for="module in modules" :key="module.module_key" class="col-sm-6 col-xl-4">
               <div class="card bg-sa-card h-100 mb-0">
                  <div class="card-body bg-sa-card-body d-flex gap-3">
                     <i :class="[module.icon || 'fa fa-cube', 'fa-2x fa-fw sa-core-color opacity-75']"></i>
                     <div class="flex-grow-1">
                        <div class="d-flex align-items-center justify-content-between gap-2">
                           <strong class="sa-core-color">{{ module.module_name }}</strong>

                           <span v-if="module.module_type === 'always_on'" class="badge bg-secondary">Included</span>
                           <div v-else class="form-check form-switch mb-0 apps-switch">
                              <input
                                 class="form-check-input"
                                 type="checkbox"
                                 role="switch"
                                 :checked="module.is_enabled"
                                 :disabled="!canManage || saving === module.module_key"
                                 :title="module.is_enabled ? 'Switch off' : 'Switch on'"
                                 @change="toggleModule(module, $event.target.checked)"
                              />
                           </div>
                        </div>

                        <small v-if="module.description" class="d-block sa-core-color opacity-75 mt-1">{{ module.description }}</small>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         <div v-if="modulesLoaded && !modules.length" class="text-center sa-core-color opacity-75 py-4">
            No modules yet.
         </div>
      </div>
   </div>
   <!--End Modules-->
</template>
<script>
import PageStatus from "../../../components/admin/PageStatus.vue";
import appsMixin from "./mixins/appsMixin.js";
import tableMixin from "@/mixins/tableMixin.js";

export default {
   name: 'Apps',
   props: {
      inModal: { type: Boolean, default: false }, // shown inside the "Add apps" popup (no page heading)
   },
   mixins: [tableMixin, appsMixin], // shared methods first (alerts, loader), then this page's own
   components: {
      PageStatus,
   },
   data() {
      return {
         // Standard data (tableData, defaultAlert ...) comes from tableMixin
         apiUrl: "/settings/api_modules.php",
         pageIcon: 'fa fa-th-large', // same icon as this page in the sidebar
         modules: [],          // always-on + selectable modules, with their switch state
         modulesLoaded: false, // the empty / "only Administrator" notes wait for the first load
         canManage: false,     // Administrator (or developer)
         saving: "",           // module being saved (its switch is disabled meanwhile)
         isDeveloper: false,   // developer: always every module in the menu
         rolePermissions: [],  // the role's full permissions, for updating the menu instantly
      };
   },
   created() {
      this.fetchModules();
   },
   computed: {
      pageTitle() {
         return "Apps";
      },
   },
   methods: {
      // Table defaults: the standard ones (tableMixin); this page has no table
      getDefaultTableData() {
         return {
            ...this.baseTableData(),
         };
      },
      getDefaultFormInputs() {
         return {};
      },
   },
};
</script>